import { ELENCOS_SERIE_A_ITALIA, type JogadorItalia } from './liga-italia-elencos';

/**
 * Série A da Itália 2026/27 (aba "internacional" das Tabelas). Por enquanto é o cadastro dos 20 clubes e dos elencos com a posição
 * de cada jogador (conhecimento/dados/serie-a-italia_elencos.csv): o jogo ainda não tem força, valor nem calendário dessa liga,
 * então ela só pode ser consultada, não disputada.
 */
export const NOME_SERIE_A_ITALIA = 'Série A da Itália';

export interface ClubeItalia {
  /** nome curto, também a chave em ELENCOS_SERIE_A_ITALIA */
  nome: string;
  estadio: string;
  cidade: string;
}

export const SERIE_A_ITALIA: ClubeItalia[] = [
  { nome: 'Atalanta', estadio: 'Gewiss Stadium', cidade: 'Bergamo' },
  { nome: 'Bologna', estadio: "Renato Dall'Ara", cidade: 'Bolonha' },
  { nome: 'Cagliari', estadio: 'Unipol Domus', cidade: 'Cagliari' },
  { nome: 'Como', estadio: 'Giuseppe Sinigaglia', cidade: 'Como' },
  { nome: 'Fiorentina', estadio: 'Artemio Franchi', cidade: 'Florença' },
  { nome: 'Frosinone', estadio: 'Benito Stirpe', cidade: 'Frosinone' },
  { nome: 'Genoa', estadio: 'Luigi Ferraris', cidade: 'Gênova' },
  { nome: 'Inter', estadio: 'Giuseppe Meazza (San Siro)', cidade: 'Milão' },
  { nome: 'Juventus', estadio: 'Allianz Stadium', cidade: 'Turim' },
  { nome: 'Lazio', estadio: 'Olimpico', cidade: 'Roma' },
  { nome: 'Lecce', estadio: 'Via del Mare', cidade: 'Lecce' },
  { nome: 'Milan', estadio: 'Giuseppe Meazza (San Siro)', cidade: 'Milão' },
  { nome: 'Monza', estadio: 'U-Power Stadium', cidade: 'Monza' },
  { nome: 'Napoli', estadio: 'Diego Armando Maradona', cidade: 'Nápoles' },
  { nome: 'Parma', estadio: 'Ennio Tardini', cidade: 'Parma' },
  { nome: 'Roma', estadio: 'Olimpico', cidade: 'Roma' },
  { nome: 'Sassuolo', estadio: 'Mapei Stadium', cidade: 'Reggio Emilia' },
  { nome: 'Torino', estadio: 'Olimpico Grande Torino', cidade: 'Turim' },
  { nome: 'Udinese', estadio: 'Bluenergy Stadium', cidade: 'Údine' },
  { nome: 'Venezia', estadio: 'Pier Luigi Penzo', cidade: 'Veneza' },
];

/** Ordem em que as posições aparecem na lista do elenco. */
export const ORDEM_POSICOES_ITALIA = ['Goleiro', 'Zagueiro', 'Lateral Esq.', 'Lateral Dir.', 'Volante', 'Meia Central', 'Meia Direita', 'Meia Esquerda', 'Meia Ofensivo', 'Ponta-Esquerda', 'Ponta-Direita', 'Seg. Atacante', 'Centroavante'];

/** Elenco do clube, agrupado por posição na ordem de ORDEM_POSICOES_ITALIA (dentro de cada posição, a ordem da fonte). */
export function elencoDaItalia(clube: string): JogadorItalia[] {
  const lista = ELENCOS_SERIE_A_ITALIA[clube] ?? [];
  const ordem = (p: string): number => {
    const i = ORDEM_POSICOES_ITALIA.indexOf(p);
    return i < 0 ? ORDEM_POSICOES_ITALIA.length : i;
  };
  return [...lista].sort((a, b) => ordem(a[1]) - ordem(b[1]));
}
